module.exports = __webpack_public_path__ + "img/list-next-arrow.8ac4ee5c.svg";